import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wen-icon-unamused',
  templateUrl: './unamused.component.html',
  styleUrls: ['./unamused.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnamusedIconComponent {}
